module.exports = __webpack_public_path__ + "img/24.2ce8d0a5.png";